import { createNullableProvideInject } from '@collector/shared-ui'
import { IncidentId } from '@collector/sportsapi-client-legacy'

export const [
  provideIncidentsRequireConfirmation,
  injectIncidentsRequireConfirmation,
] = createNullableProvideInject<IncidentId[]>('incidentsRequireConfirmation')
